<script context="module" lang="ts">
  export function elementContainsEventTarget (
    el: HTMLElement,
    e: MouseEvent | FocusEvent | PointerEvent
  ): boolean {
    const target = 
           (e.relatedTarget instanceof Element && e.relatedTarget) 
        || (e.target instanceof Element && e.target)
        || null;
    return el?.contains(target);
  }
</script>

<script lang="ts">

  import { createEventDispatcher, getContext } from "svelte";
  import { VisioMapApp } from "./vg/visiomap";

  const app = getContext<VisioMapApp>('app');
  const { fullscreen } = app;
  
  let toggle = false;
  let overlay_el: HTMLElement;

  $: active = !$fullscreen;
  $: visible = active && toggle;

  const dispatch = createEventDispatcher()
  
  function toggleOn (e: Event) {
    // console.log('toggleOn', e);
    
    if (!toggle) {
      toggle = true;
      overlay_el.focus();
      e.preventDefault();
    }
  }

  function contains (e: MouseEvent | FocusEvent | PointerEvent) {
    if (toggle && overlay_el) {
      toggle = elementContainsEventTarget(overlay_el, e);
    };
  }

  function detectDoubleTapClosure() {
    let lastTap = 0;
    return function detectDoubleTap(event: TouchEvent) {
      const curTime = new Date().getTime();
      const tapLen = curTime - lastTap;
      if (tapLen < 500 && tapLen > 0) {
        console.log('Double tapped!');
        event.preventDefault();
        dispatch('dblclick');
      }
      lastTap = curTime;
    };
  }
</script>

{#if !$fullscreen}
  <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
  <div class="overlay" class:active class:visible
    tabindex={0}
    bind:this={overlay_el}
    on:mousedown={toggleOn} on:keyup={toggleOn}
    on:dragstart={toggleOn} on:wheel={toggleOn}
    on:focus={toggleOn} on:pointerdown={toggleOn}
    on:touchend={detectDoubleTapClosure()}
    on:mouseout={contains} on:blur={contains}
    on:dblclick>
    <slot>
      <p>Douple tap to interact with the map!</p>
    </slot>
  </div>
{/if}

<svelte:document on:click={contains} />

<style>
  .overlay {
    position: absolute;
    display: flex;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: var(--_p4);

    align-items: center;
    justify-content: center;

    background-color: transparent;
    font-size: 21px;
    font-weight: 500;
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
    text-align: center;

    transition: opacity 200ms;
    user-select: none;
    z-index: 10;
  }

  .overlay > :global(*:last-child) {
    margin-bottom: 0;
  }

  .active {
    background-color: rgba(0,0,0,.4);
    color: #fff;
    visibility: visible;
    pointer-events: all;
    text-shadow: 0 0 4px rgba(0,0,0,.2);
  }

  .visible {
    opacity: 1;
  }
</style>